import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencilAi: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil-ai, edit, write, auto-write, prompt-suggestion, auto-prompt"><path d="M16.0294 4.82353L5.27941 15.5735L4.25 21.75L10.4265 20.7206L21.1765 9.97059C22.5978 8.54927 22.5978 6.24485 21.1765 4.82353C19.7552 3.40221 17.4507 3.40221 16.0294 4.82353Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M15 6L20 11" stroke="currentColor" strokeWidth="1.5"/><path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPencilAi;
